import { API_URL, jwtToken } from "../../../context/appContext";
export default async function createUser(data) {
    return fetch(`${API_URL}/api/create_user`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        }, body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
